export const CATEGORIES = [
  { value: "Travelling", label: "Travelling" },
  { value: "IT", label: "IT" },
  { value: "Marketing", label: "Marketing" },
  { value: "Tech", label: "Tech" },
];
export const SUBSCRIPTIONS = [
  { value: "paid", label: "Paid" },
  { value: "pending", label: "Pending" },
];

export const CATEGORIES_FILTER = [
  { value: "All", label: "Category" },
  { value: "Travelling", label: "Travelling" },
  { value: "IT", label: "IT" },
  { value: "Marketing", label: "Marketing" },
  { value: "Tech", label: "Tech" },
];

export const SUBSCRIPTION_FILTER = [
  { value: "All", label: "Subscription" },
  { value: "paid", label: "Paid" },
  { value: "pending", label: "Pending" },
];
